import React, { useEffect, useContext, useState, useRef } from 'react'
import { Box, Button } from '@material-ui/core'

import EditableField from "./EditableField"

const EditableButton = ({type, buttonName, field, isEditor, sx, onClick, disabled}) => {
  if (isEditor) {
    return (
      <Button
        sx={{
          ...sx,
          fontSize:["15px !important", "16px !important"],
          height:["45px !important", "50px !important"],
          minHeight:["45px !important", "50px !important"],
          whiteSpace:"noWrap",
        }}
        size="large"
        type="submit"
        variant="contained"
        disableRipple
      >
        <EditableField
          field={field}
          type={type}
          buttonName={buttonName?buttonName:"button"}
          isEditor={true}
        />
      </Button>
    )
  } else {
    return (
      <Button
        sx={{
          ...sx,
          fontSize:["15px !important", "16px !important"],
          height:["45px !important", "50px !important"],
          minHeight:["45px !important", "50px !important"],
          whiteSpace:"noWrap",
        }}
        disabled={disabled}
        onClick={onClick}
        size="large"
        type="submit"
        variant="contained"
      >
        {field}
      </Button>
    )
  }
}

export default EditableButton
